import { BaseResource } from 'e100-data-providers';
import { TRestProvider } from 'dataSources/types/restProvider';
import { NativeGeocodeResponse, SearchPrediction } from './types';
import { EMPTY_STRING } from 'common/constants';
import { defaultBBox } from 'common/utils';
import {
  Response,
  TransportMode,
} from 'common/utils/directionsService/YandexDirectionService/types';

export * from './types';

class Maps extends BaseResource {
  path: string = EMPTY_STRING;

  constructor(provider: TRestProvider) {
    super(provider);
    this.path = 'maps';
  }

  searchPrediction({
    geocode,
    lang,
    limit,
  }: SearchPrediction): NativeGeocodeResponse {
    return this.send(
      this.getChildResource(
        `search?geocode=${geocode}&lang=${lang}&format=json&results=${limit}&bbox=${defaultBBox[0]},${defaultBBox[1]}~${defaultBBox[2]},${defaultBBox[3]}`,
      ).request.get(),
    );
  }

  searchRoute({
    waypoints,
    mode,
    avoid_tolls = false,
  }: {
    waypoints: string;
    mode: TransportMode;
    avoid_tolls?: boolean;
  }): Promise<Response> {
    return this.send(
      this.getChildResource(
        `route?waypoints=${waypoints}&mode=${mode}&avoid_tolls=${avoid_tolls}`,
      ).request.get(),
    );
  }
}

export default Maps;
